import axios from "axios";
import {getSelfToken} from '../../_helpers/auth/secureToken'
import {playistEndpoint} from '../_constants/api.constant'
export async function removeSongFromPlaylist(playlistId,dataObj) {
    const response = await axios.post(
        playistEndpoint.REMOVE_SONG_FROM_PLAYLIST+playlistId,
        dataObj,
        {   
            headers: {
                'Authorization': 'Token ' + getSelfToken(),
            },
        }
    ).then(function (response) {
        return response;
    }).catch(function (error) {
        return error.response;
    });
    return response
}